<div class="d-flex flex-column" >






<div class="card p-0" style="background-color:  #f4f4f4" *ngIf="agency">
  <!-- <div class="d-flex flex-row justify-content-between align-items-center header-pay px-4">
    <h5 class="color-green font-weight-bold font-poppins m-0">FORMAS DE PAGO</h5>
    <div class="d-flex align-items-center">
      <p class="p-0 m-0 mr-2 font-poppins">TOTAL IMPORTE</p>
      <p class="p-0 m-0 monto font-poppins">$ {{totalPrice | number:'1.2-2'}}</p>
    </div>
  </div> -->

  <div class="p-4">

    <h5 class="font-poppins m-0" style="font-size: 18px;">FORMAS DE PAGO</h5>

    <ng-container *ngIf="currencyAgency?.code !== 'USD' && !userService._isGuest">
      <div class="d-flex align-items-center" style="gap: 1em;">
        <div class="d-flex">
          <p class="font-poppins mb-0" style="font-size: 24px; font-weight: 500;">Moneda de pago</p>
          <i *ngIf="!creditCardPending && !creditCardPayPartial" class="fa fa-question-circle"
             style="font-size: .75rem;cursor: help;"
              [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"
             aria-hidden="true"
             title="La moneda seleccionada será utilizada para el pago. Si actualiza la moneda una vez introducidos los datos estos se reiniciaran"
          ></i>
        </div>
        <select *ngIf="!creditCardPending && !creditCardPayPartial"
          class="form-control input-search-box"
          style="width: fit-content; height: 30px !important; font-size: 12px !important; "
          (change)="changeCurrencyPayment($event.target.value)"
        >

      <ng-container *ngFor="let currency of currencies">
        <ng-container *ngIf="currency.code === 'USD' || currency.code === currencyAgency?.code">
          <option style="font-size: 14px !important; font-weight: 500 !important; color: black !important" value="{{currency.code}}" [selected]="currency.code === currencyAgency?.code">{{currency.code}}</option>
        </ng-container>
      </ng-container>
    </select>
    <ng-container *ngIf="creditCardPending || creditCardPayPartial">
      <p class="font-poppins mb-0" style="font-size: 24px; font-weight: 500;">USD</p>
    </ng-container>
    </div>
    </ng-container>
    <div class="d-flex">

      <p *ngIf="creditCardDataPending.length === 0" class="p-0 m-0 font-poppins" style="font-size: 24px; font-weight: 600;">
        Total importe:
         {{currencyPayment}} {{totalPrice | number:'1.2-2'}}
           <!-- {{currencyAgency?.code !== currencyPayment ? currencyPayment : currencyAgency?.code}} {{ totalPrice
                                        | currencyConverterPure:
                                          currencyItinerary:
                                          currencyAgency?.code !== currencyPayment ? currencyPayment : currencyAgency?.code:
                                          currencies
                                        | number: '1.2-2'}} -->
      <!-- </p> -->
      <p *ngIf="creditCardDataPending.length > 0 && !creditCardPayPartial" class="p-0 m-0 font-poppins" style="font-size: 24px; font-weight: 600;">
        Total importe:
         USD {{amountCreditCard | number:'1.2-2'}}</p>
         <!-- {{currencyAgency?.code !== currencyPayment ? currencyPayment : currencyAgency?.code}} {{ amountCreditCard
                                        | currencyConverterPure:
                                          currencyItinerary:
                                          currencyAgency?.code !== currencyPayment ? currencyPayment : currencyAgency?.code:
                                          currencies
                                        | number: '1.2-2'}} -->
      <!-- </p> -->
      <p *ngIf="creditCardPayPartial" class="p-0 m-0 font-poppins" style="font-size: 24px; font-weight: 600;">
        Total importe:
        <!-- {{currencyAgency?.code !== currencyPayment ? currencyPayment : currencyAgency?.code}} {{ totalPrice
                                        | currencyConverterPure:
                                          currencyItinerary:
                                          currencyAgency?.code !== currencyPayment ? currencyPayment : currencyAgency?.code:
                                          currencies
                                        | number: '1.2-2'}}
                                      </p> -->
       usd {{totalPrice | number:'1.2-2'}}</p>

                  <div class="info-tool d-flex flex-column position-relative">
                   <i class="fa fa-info-circle"
                   aria-hidden="true"
                   style="font-size: 13px;"
                   [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i>
                  <span class="tooltip-info shadow-md">
                    <table class="table-info-tool">
                      <tr style="border-bottom: 1px solid #ececec;">
                        <th style="text-align: center">
                          <p>Cambio</p>
                        </th>
                      </tr>
                      <ng-container *ngFor="let currency of currencies">
                        <tr *ngIf="currency.code !== currencyPayment ">
                          <td>
                            <p *ngIf="creditCardDataPending.length === 0" class="mb-2">
                              <span style="color: black"> {{ currency.code }}</span>
                                 <span style="font-weight: 600; color: black;">&nbsp;{{
                                totalPrice | currencyConverter: currencyPayment: currency.code: currencies
                              }}</span>
                            </p>
                            <p *ngIf="creditCardDataPending.length > 0 && !creditCardPayPartial" class="mb-2">
                               <span style="color: black">{{ currency.code }} </span>
                                <span style="font-weight: 600; color: black;">&nbsp; {{
                                 amountCreditCard | currencyConverter: 'USD': currency.code: currencies
                              }}</span>
                            </p>
                            <p *ngIf="creditCardPayPartial" class="mb-2">
                              <span style="color: black"> {{ currency.code }}</span>
                                 <span style="font-weight: 600; color: black;">&nbsp; {{
                               totalPrice | currencyConverter: 'USD': currency.code: currencies
                              }}</span>
                            </p>
                          </td>
                        </tr>
                      </ng-container>
                    </table>
                  </span>
                </div>
    </div>

    <p *ngIf="errorOverpay" class="font-poppins mb-0 mt-2" style="color: red; font-weight: 600; font-size: 13px;">
      El total ingresado entre los métodos de pago supera el importe a pagar. Ajustá los montos para que sumen {{currencyPayment}} {{totalPrice | number:'1.2-2'}}.
    </p>

</div>

  <div class="d-flex flex-column px-4 pb-4">
    <!-- BLICKOINS -->
    <ng-container *ngIf="agency && blickoinsPay && !userService._isGuest">

      <div class="pay-method d-flex align-items-center justify-content-between flex-row mt-3 position-relative"
           (click)="toggleOpenPanel(1)">

        <!-- <input type="checkbox" class="ml-3" (change)="pointsChange()" [(ngModel)]="isPointsSelected">  -->
        <span span class="label-check ml-2 font-poppins">POR BLICKOINS
          <span *ngIf="amountPoints > 0">({{currencyPayment}} {{amountPoints | number:'1.2-2'}})</span>
          <span class="fee-badge" *ngIf="getMethodFeePercentage(1) > 0">+{{getMethodFeePercentage(1) | number:'1.0-2'}}%</span>
        </span>
        <span class="mb-0 d-flex">
          <label class="custom-radio-checkbox mb-0" *ngIf="verifyPaymentMethod(1)">
            <input class="custom-radio-checkbox__input" type="checkbox" (change)="pointsChange()"
              (click)="$event.stopPropagation()"
              [(ngModel)]="isPointsSelected">
            <!-- <span class="custom-radio-checkbox__show custom-radio-checkbox__show--radio"></span> -->
          </label>
        </span>


          <span
          *ngIf="openMethodId !== 1"
            style="position: absolute;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      border-top-right-radius: 4px;
                      border-bottom-right-radius: 4px;
                      right: 0;
                      height: 45px;
                      width: 55px;"
                      [ngStyle]="{'background-color': isPointsSelected ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}">

               <i class="fa fa-caret-down"
                  aria-hidden="true"
                  [style.color]="
                                getClientsSettingAppBooking?.clients_setting_global?.color_main_1">
                </i>
          </span>

          <span
          *ngIf="openMethodId === 1"
          style="position: absolute;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      border-top-right-radius: 4px;
                      border-bottom-right-radius: 4px;
                      right: 0;
                      height: 45px;
                      width: 55px;"
                      [ngStyle]="{'background-color': isPointsSelected ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}">

               <i class="fa fa-caret-up"
                  aria-hidden="true"
                  [style.color]="
                                getClientsSettingAppBooking?.clients_setting_global?.color_main_2">
                </i>
          </span>


      </div>
<ng-container *ngIf="openMethodId === 1">

  <div [@slideInOut]="openMethodId === 1 ? 'in' : 'out'">
    <div class="row mx-0 pt-3 pb-3"  style="background-color: #deeae7;border-bottom-right-radius: 6px; border-bottom-left-radius: 6px;">
      <div class="col-7 pl-4">
        <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 600;">Forma de pago</p>
        <p class="font-poppins" style="font-size: 13px; font-weight: 600;">BLICKOINS</p>
      </div>
      <div class="col-5">
        <div *ngIf="totalPrice" style="display: flex; justify-content: space-around;">
          <div>
            <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 600;">TARIFA NETA</p>
            <p class="font-poppins" style="font-size: 18px; font-weight: 600;"> {{currencyPayment}} {{ totalPrice | number:'1.2-2' }}</p>
          </div>
          <div>
            <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 700;">A PAGAR</p>
            <p class="font-poppins" style="font-size: 18px; font-weight: 700;"> {{currencyPayment}} {{ (leftTotal > 0 ? leftTotal : 0) | number:'1.2-2' }}</p>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class=" col-12 d-flex justify-content-between">
          <div class="col-6 mt-3 d-flex flex-column justify-content-center text-center box-points" style="border-radius: 6px;"
              [ngClass]="{'border-red': ((currencyPayment !== 'USD' && currencyAgency?.code !== 'USD' ? ((amountPoints / currencyAgency.rate) > creditBlickoinsActives) : amountPoints > creditBlickoinsActives)) || (amountPoints > totalPrice)}">
              <p class="mb-0 total-points font-poppins">TOTAL BLICKOINS <span class="ml-2">{{currencyItinerary}} {{creditBlickoinsActives | number:'1.2-2'}}</span>
              </p>
              <P *ngIf="currencyPayment === 'USD'" class="mb-0 saldo-points font-poppins"
                [ngClass]="{'color-red': (amountPoints > creditBlickoinsActives) || (amountPoints > totalPrice)}">
                SALDO BLICKCOINS
                <span class="ml-2" [ngClass]="{'color-red': (amountPoints > creditBlickoinsActives) || (amountPoints > totalPrice)}">
                  USD {{( (creditBlickoinsActives - amountPoints) > 0 ? (creditBlickoinsActives - amountPoints) : creditBlickoinsActives) | number:'1.2-2'}}
                </span>
              </P>
              <P *ngIf="currencyPayment !== 'USD' && currencyAgency?.code !== 'USD'" class="mb-0 saldo-points font-poppins"
                [ngClass]="{'color-red': ((amountPoints / currencyAgency.rate) > creditBlickoinsActives) || (amountPoints > totalPrice)}">
                SALDO BLICKCOINS
                <span class="ml-2" [ngClass]="{'color-red': ((amountPoints / currencyAgency.rate) > creditBlickoinsActives) || ((amountPoints / currencyAgency.rate) > totalPrice)}">
                  USD {{ (creditBlickoinsActives - (amountPoints / currencyAgency.rate) > 0 ? creditBlickoinsActives - (amountPoints / currencyAgency.rate) : creditBlickoinsActives) | number:'1.2-2'}}
                </span>
              </P>
          </div>
          <div class="col-6 pt-3" style="display: flex; justify-content: flex-end;">
          <div class="d-flex flex-row justify-content-end  pt-3" style="display: flex; justify-content: flex-end;">
            <div class="mr-2">
              <input class="form-control input total-pay py-0 font-poppins"  id="numberInput" style="appearance: none;border-radius: 50rem;width:132.20px;height:38px; background-color: #f4f4f4;" min="0"
                      type="number"
                      #inputPoints
                      name="amountPoints"
                      [(ngModel)]="amountPoints"
                      placeholder="0,00"
                      (keydown)="blockInvalidKeys($event, 'number')"
                      [ngClass]="{'border-red': (amountPoints > totalPrice)}"
                      (input)="calculateLeftTotal()"
                      (wheel)="preventScroll($event)"
                      [disabled]="creditBlickoinsActives === 0">
              <p *ngIf="amountPoints <= totalPrice && amountPoints >= 0" class="mb-0 text-center text-totals font-poppins" style="font-size: 12px !important;"
                  >PAGO A REALIZAR</p>
              <p *ngIf="amountPoints < 0" class="mb-0 text-center text-danger text-totals font-poppins" style="font-size: 12px !important;">Monto invalido</p>
              <p *ngIf="amountPoints > totalPrice" class="mb-0 text-center text-danger text-totals font-poppins" style="font-size: 12px !important;">Máximo excedido</p>
            </div>
            <div>
              <button type="btn"
                      class="btn font-poppins"
                      [disabled]="creditBlickoinsActives === 0 || leftTotal === 0"
                      style="font-size:12px;font-weight: 600; border-radius: 50rem;border: 1px solid black;height:38px;"
                      [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"
                      (click)="payTotal(1)">PAGAR COMPLETO</button>
            </div>
          </div>
          </div>
        </div>
      </div>
        <div *ngIf="currencyPayment !== 'USD' && currencyAgency?.code !== 'USD'" class="mx-4 d-flex justify-content-between" style="width: 94%;">
          <div class="col-12 d-flex flex-column  justify-content-center pb-3" style="border-radius: 6px;">
        <p class="mb-0 font-poppins" style="font-size: 14px;">
            Conversión aplicada:
        </p>
        <p class="mb-0 font-poppins" style="font-size: 12px;">
            {{amountPoints | number:'1.2-2'}} {{currencyPayment}}
            ÷ {{currencyAgency?.rate | number:'1.2-2'}}
            = {{(amountPoints / currencyAgency?.rate) | number:'1.2-2'}} USD
        </p>
        <p class="mb-0 font-poppins" style="font-size: 12px;">
            Saldo en créditos convertido de {{currencyAgency?.code}} a USD
        </p>
    </div>
   </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="openMethodId === 1" [ngTemplateOutlet]="feeEstimate" [ngTemplateOutletContext]="{ $implicit: 1 }"></ng-container>
    </ng-container>

    <!-- DEPOSIT -->
    <ng-container *ngIf="agency && creditDepositPay && !userService._isGuest">
      <div class="pay-method d-flex align-items-center justify-content-between flex-row mt-2 position-relative" (click)="toggleOpenPanel(3)">
        <span class="label-check ml-2 font-poppins">POR DEPOSITO
          <span *ngIf="amountDeposit > 0">({{currencyPayment}} {{amountDeposit | number:'1.2-2'}})</span>
          <span class="fee-badge" *ngIf="getMethodFeePercentage(3) > 0">+{{getMethodFeePercentage(3) | number:'1.0-2'}}%</span>
        </span>
        <span class="mb-0 d-flex">
          <label class="custom-radio-checkbox mb-0"  *ngIf="verifyPaymentMethod(3)">
            <input class="custom-radio-checkbox__input"
                    type="checkbox"
                    [(ngModel)]="isDepositSelected"
              (change)="creditChange()"
              (click)="$event.stopPropagation()">
            <!-- <span class="custom-radio-checkbox__show custom-radio-checkbox__show--radio"></span> -->
          </label>
        </span>
         <span
          *ngIf="openMethodId !== 3"
            style="position: absolute;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      border-top-right-radius: 4px;
                      border-bottom-right-radius: 4px;
                      right: 0;
                      height: 45px;
                      width: 55px;"
                      [ngStyle]="{'background-color': isDepositSelected ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}">

               <i class="fa fa-caret-down"
                  aria-hidden="true"
                  [style.color]="
                                getClientsSettingAppBooking?.clients_setting_global?.color_main_1">
                </i>
          </span>

          <span
          *ngIf="openMethodId === 3"
          style="position: absolute;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      border-top-right-radius: 4px;
                      border-bottom-right-radius: 4px;
                      right: 0;
                      height: 45px;
                      width: 55px;"
                      [ngStyle]="{'background-color': isDepositSelected ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}">

               <i class="fa fa-caret-up"
                  aria-hidden="true"
                  [style.color]="
                                getClientsSettingAppBooking?.clients_setting_global?.color_main_2">
                </i>
          </span>

      </div>

<ng-container *ngIf="openMethodId === 3">

  <div [@slideInOut]="openMethodId === 3 ? 'in' : 'out'">
    <div class="row mx-0 pt-3 pb-3"  style="background-color: #deeae7;border-bottom-right-radius: 6px; border-bottom-left-radius: 6px;">
      <div class="col-7 pl-4">
        <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 600;">Forma de pago</p>
        <p class="font-poppins" style="font-size: 13px; font-weight: 600;">DEPOSITO</p>
      </div>
      <div class="col-5">
        <div *ngIf="totalPrice" style="display: flex; justify-content: space-around;">
          <div>
            <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 600;">TARIFA NETA</p>
            <!-- <p class="font-poppins" style="font-size: 18px; font-weight: 600;">{{currencyItinerary}} {{ totalPrice | number:'1.2-2' }}</p> -->
              <p class="font-poppins" style="font-size: 18px; font-weight: 600;">
               {{currencyAgency?.code !== currencyPayment ? currencyPayment : currencyAgency?.code }} {{ totalPrice | number: '1.2-2'}}
            </p>
          </div>
          <div>
            <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 700;">A PAGAR</p>
            <!-- <p class="font-poppins" style="font-size: 18px; font-weight: 700;">{{currencyItinerary}} {{ (leftTotal > 0 ? leftTotal : 0) | number:'1.2-2' }}</p> -->
              <p class="font-poppins" style="font-size: 18px; font-weight: 700;">
               {{currencyAgency?.code !== currencyPayment ? currencyPayment : currencyAgency?.code}} {{ (leftTotal > 0 ? leftTotal : 0) | number: '1.2-2'}}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 d-flex justify-content-between">
          <div class=" col-6 mt-3 d-flex flex-column justify-content-center text-center box-points" style="border-radius: 6px;"
          [ngClass]="{'border-red': (amountDeposit > creditDepositActives) || (amountDeposit > totalPrice)}">
          <p class="mb-0 total-points font-poppins">TOTAL DEPOSITO EN GARANTÍA
            <span class="ml-2">
              <!-- {{currencyItinerary}} {{creditDepositActives | number:'1.2-2'}} -->
              {{currencyAgency?.code}} {{creditDepositActives | number: '1.2-2'}}
            </span>
          </p>
          <P class="mb-0 saldo-points font-poppins"
          [ngClass]="{'color-red': (amountDeposit > creditDepositActives) || (amountDeposit > totalPrice)}">
          SALDO CRÉDITOS
            <span class="ml-2"
                  [ngClass]="{'color-red': (amountDeposit > creditDepositActives) || (amountDeposit > totalPrice)}">
                  <!-- {{currencyItinerary}} {{ (amountDeposit >= 0 && (creditDepositActives - amountDeposit) > 0) ? (creditDepositActives - amountDeposit) : creditDepositActives | number:'1.2-2'}} -->
                     {{currencyAgency?.code}}
                     {{((amountDeposit >= 0 && (creditDepositActives - amountDeposit) > 0) ?
                        currencyAgency?.code !== currencyPayment ?
                        (creditDepositActives - (amountDeposit * currencyAgency?.rate))
                        : (creditDepositActives - amountDeposit)
                        : creditDepositActives)
                        | number: '1.2-2'}}
            </span>
          </P>
        </div>

        <div class="col-6 pt-3" style="display: flex; justify-content: flex-end;">
          <div class="mr-2">
              <input class="form-control input font-poppins"
                      id="numberInput"
                      style="appearance: none;border-radius: 50rem;width:132.20px;height:38px;background-color: #f4f4f4;" min="0"
                      type="number"
                      placeholder="0,00"
                      (wheel)="preventScroll($event)"
                      [ngClass]="{'border-red': (amountDeposit > totalPrice)}"
                      #inputDeposit
                      name="amountDeposit"
                      [max]="totalPrice"
                      [(ngModel)]="amountDeposit"
                      (input)="calculateLeftTotal()"
                      (keydown)="blockInvalidKeys($event, 'number')"
                      [disabled]="creditDepositActives === 0">
            <p *ngIf="amountDeposit <= totalPrice && amountDeposit >= 0" class="mb-0 text-center text-totals font-poppins" style="font-size: 12px !important;">PAGO A REALIZAR</p>
            <p *ngIf="amountDeposit < 0" class="mb-0 text-center text-danger text-totals font-poppins" style="font-size: 12px !important;">Monto invalido</p>
            <p *ngIf="amountDeposit > totalPrice" class="mb-0 text-center text-danger text-totals font-poppins" style="font-size: 12px !important;">Máximo excedido</p>
          </div>
          <div>
            <button type="btn"
                    class="btn font-poppins"
                    style="font-size:12px;font-weight: 600; border-radius: 50rem;border: 1px solid black;height:38px;"
                    [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"
                    [disabled]="creditDepositActives === 0 || leftTotal === 0"
                    (click)="payTotal(2)">PAGAR COMPLETO</button>
          </div>
        </div>
      </div>
    </div>
   <div *ngIf="currencyAgency?.code !== currencyPayment" class="mx-4 d-flex justify-content-between" style="width: 94%;">
    <div class="col-12 mt-3 d-flex flex-column  justify-content-center pb-3" style="border-radius: 6px;">
        <p class="mb-1 font-poppins" style="font-size: 14px;">
            <i class="fa fa-info-circle"></i> Conversión aplicada:
        </p>
        <p class="mb-0 font-poppins" style="font-size: 12px;">
            {{amountDeposit | number:'1.2-2'}} {{currencyPayment}}
            × {{currencyAgency?.rate | number:'1.2-2'}}
            = {{(amountDeposit * currencyAgency?.rate) | number:'1.2-2'}} {{currencyAgency?.code}}
        </p>
        <p class="mb-0 font-poppins" style="font-size: 12px;">
            Saldo en créditos convertido de {{currencyAgency?.code}} a {{currencyPayment}}
        </p>
    </div>
   </div>

  </div>
  </div>
</ng-container>
<ng-container *ngIf="openMethodId === 3" [ngTemplateOutlet]="feeEstimate" [ngTemplateOutletContext]="{ $implicit: 3 }"></ng-container>

    </ng-container>

    <!-- TRANSFERENCIA -->
    <ng-container *ngIf="agency && transferPay && !userService._isGuest">

      <div class="pay-method d-flex align-items-center justify-content-between flex-row mt-2 position-relative" (click)="toggleOpenPanel(4)">
        <span class="label-check ml-2 font-poppins">POR TRANSFERENCIA
          <span *ngIf="amountTranfer > 0">({{currencyPayment}} {{amountTranfer | number:'1.2-2'}})</span>
          <span class="fee-badge" *ngIf="getMethodFeePercentage(4) > 0">+{{getMethodFeePercentage(4) | number:'1.0-2'}}%</span>
        </span>
        <span class="mb-0 d-flex">
          <label class="custom-radio-checkbox mb-0"  *ngIf="verifyPaymentMethod(4)">
            <input class="custom-radio-checkbox__input" type="checkbox" [(ngModel)]="isTranferSelected"
              (change)="tranferChange()"
              (click)="$event.stopPropagation()" >
            <!-- <span class="custom-radio-checkbox__show custom-radio-checkbox__show--radio"></span> -->
          </label>
        </span>
        <span
          *ngIf="openMethodId !== 4"
            style="position: absolute;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      border-top-right-radius: 4px;
                      border-bottom-right-radius: 4px;
                      right: 0;
                      height: 45px;
                      width: 55px;"
                      [ngStyle]="{'background-color': isTranferSelected ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}">

               <i class="fa fa-caret-down"
                  aria-hidden="true"
                  [style.color]="
                                getClientsSettingAppBooking?.clients_setting_global?.color_main_1">
                </i>
          </span>

          <span
          *ngIf="openMethodId === 4"
          style="position: absolute;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      border-top-right-radius: 4px;
                      border-bottom-right-radius: 4px;
                      right: 0;
                      height: 45px;
                      width: 55px;"
                      [ngStyle]="{'background-color': isTranferSelected ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}">

               <i class="fa fa-caret-up"
                  aria-hidden="true"
                  [style.color]="
                                getClientsSettingAppBooking?.clients_setting_global?.color_main_2">
                </i>
          </span>


          <!-- <i class="mr-3 ml-auto"
          [ngClass]="{'icons-transfer': !isTranferSelected, 'icons-transfer-dark': isTranferSelected}"></i> -->
        </div>

      <ng-container *ngIf="openMethodId === 4">
      <div [@slideInOut]="openMethodId === 4 ? 'in' : 'out'">
        <div class="row mx-0 pt-3 pb-3"   style="background-color: #deeae7;border-bottom-right-radius: 6px; border-bottom-left-radius: 6px;">
          <div class="col-7 pl-4">
            <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 600;">Forma de pago</p>
            <p class="font-poppins" style="font-size: 13px; font-weight: 600;">TRANSFERENCIA</p>
          </div>
          <div class="col-5">
            <div *ngIf="totalPrice" style="display: flex; justify-content: space-around;">
              <div>
                <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 600;">TARIFA NETA</p>
                <p class="font-poppins" style="font-size: 18px; font-weight: 600;">
                   {{currencyAgency?.code !== currencyPayment ? currencyPayment : currencyAgency?.code}} {{ totalPrice | number: '1.2-2'}}
                </p>
                <!-- <p class="font-poppins" style="font-size: 18px; font-weight: 600;">{{currencyItinerary}} {{ totalPrice | number:'1.2-2' }}</p> -->
              </div>
              <div>
                <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 700;">A PAGAR</p>
                <p class="font-poppins" style="font-size: 18px; font-weight: 700;">
                   {{currencyAgency?.code !== currencyPayment ? currencyPayment : currencyAgency?.code}} {{ (leftTotal > 0 ? leftTotal : 0) | number: '1.2-2'}}
                </p>
                <!-- <p class="font-poppins" style="font-size: 18px; font-weight: 700;">{{currencyItinerary}} {{ (leftTotal > 0 ? leftTotal : 0) | number:'1.2-2' }}</p> -->
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="col-12 d-flex justify-content-between">
              <div class="col-6 d-flex flex-row mt-3">


                <div style="position: relative">
                  <input
                          id="file"
                          type="file"
                          accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
                          style="cursor: pointer"
                          (change)="addPhoto($event)"
                          multiple
                          [disabled]="amountTranfer === 0 || amountTranfer === null || amountTranfer < 0 || filesArrayTransfer()" >

                    <p class="mt-1 lc-block" *ngIf="errorImageDimension" style="position:absolute; font-size: 10px; color: red;bottom: -2.5em; left: 2px;">El tamaño máximo permitido es de 1400px X 2100px</p>
                    <p class="mt-1 lc-block" *ngIf="errorImageFormat" style="position:absolute; font-size: 10px; color: red;bottom: -2.5em; left: 2px;">Formatos permitidos: JPG, PNG o PDF (sin contenido activo)</p>
                    <p class="mt-1 lc-block" *ngIf="errorImageSize" style="position:absolute; font-size: 10px; color: red;bottom: -2.5em; left: 2px;">El Peso máximo admitido es de 2mb.</p>
                  <label for="file" style="border-radius: 50rem;height:38px;display:flex; justify-content: center;align-items: center;border: 1px solid black;" [ngStyle]="{'filter': amountTranfer === 0 || amountTranfer === undefined ||  amountTranfer === null  || amountTranfer < 0 ? 'grayscale(1)' : 'grayscale(0)'}">
                    <i class="icons-upload-cloud mr-2"></i>
                    {{ filesArray.length < 3 ? 'Cargar cupon ' + (filesArray.length + 1) : 'Subida completada' }}
                  </label>
                  <p class="mb-1 font-poppins" style="font-size: 11px; color: #6c757d; margin-top: -4px; padding-left: 12px;">
                    Formatos admitidos: JPG, PNG o PDF · Máx. 2 MB · Hasta 3 archivos
                  </p>

                  <div class="d-flex" style="position: relative;">
                    <ng-container *ngFor="let image of filesArray;let i = index">
                      <div class="mr-3">
                        <img *ngIf="!image.isPdf" [src]="image.url" alt="" width="50px" height="50px">
                        <!-- PDF: no se renderiza (ni iframe ni object), solo ícono + nombre -->
                        <div *ngIf="image.isPdf"
                             class="d-flex flex-column align-items-center justify-content-center"
                             style="width: 50px; height: 50px; border: 1px solid #ced4da; border-radius: 4px;"
                             [title]="image.name">
                          <i class="bi bi-file-earmark-pdf" style="font-size: 22px; color: #e93a55;"></i>
                          <span style="font-size: 8px; max-width: 46px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ image.name }}</span>
                        </div>
                        <div class="remove-photo text-white" (click)="removeIMG(i)" style="display:flex;justify-content: center; cursor: pointer;">
                          <div style="font-size: 12px;margin-left:1px;">x</div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
                <div class="col-6 pt-3" style="display: flex; justify-content: flex-end;">
                  <div class="mr-2">
                    <input class="form-control input font-poppins"
                            type="number"
                            id="numberInput"
                            style="appearance: none;border-radius: 50rem;width:132.20px;height:38px;background-color: #f4f4f4;"
                            name="amountTranfer"
                            min="0"
                            max="10"
                            [(ngModel)]="amountTranfer"
                            (keydown)="blockInvalidKeys($event, 'number')"
                            placeholder="0,00"
                            (input)="calculateLeftTotal()"
                            (wheel)="preventScroll($event)"
                            #inputTranfer
                            [ngClass]="{'border-red': (amountTranfer > totalPrice)}">
                    <p *ngIf="amountTranfer <= totalPrice && amountTranfer >= 0" class="mb-0 text-center text-totals font-poppins" style="font-size: 12px !important;">PAGO A REALIZAR</p>
                    <p *ngIf="amountTranfer < 0" class="mb-0 text-center text-danger text-totals font-poppins" style="font-size: 12px !important;">Monto invalido</p>
                    <p *ngIf="amountTranfer > totalPrice" class="mb-0 text-center text-danger text-totals font-poppins" style="font-size: 12px !important;">Máximo excedido</p>
                  </div>
                  <div>
                    <button type="btn"
                    class="btn font-poppins"
                    style="font-size:12px;font-weight: 600; border-radius: 50rem;border: 1px solid black;height:38px;"
                    [disabled]="leftTotal === 0"
                    [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"
                    (click)="payTotal(3)">PAGAR COMPLETO</button>
                  </div>
                </div>
            </div>
          </div>
          <div class="col-12">
            <p class="mt-4 mb-0 mr-2" style="font-size: 10pt;text-align: end; color: black;">Queda sujeto a validación en las próximas 48hs de recibido el comprobante</p>
          </div>
        </div>

      </div>
</ng-container>
<ng-container *ngIf="openMethodId === 4" [ngTemplateOutlet]="feeEstimate" [ngTemplateOutletContext]="{ $implicit: 4 }"></ng-container>
    </ng-container>


    <!-- TARJETA DE CREDITO -->
    <!-- USD: Square / PayPal. ARS (moneda de la agencia): solo Mercado Pago, si la agencia lo tiene -->
    <ng-container  *ngIf="agency && creditCardPay && (currencyPayment === 'USD' || isMercadoPagoEnabled())">
      <div class="pay-method d-flex align-items-center justify-content-between flex-row mt-2 position-relative"
        (click)="toggleOpenPanel(2)" >
        <span class="label-check ml-2 font-poppins">POR TARJETA
          <span *ngIf="amountCard > 0">({{currencyPayment}} {{amountCard | number:'1.2-2'}})</span>
          <span class="fee-badge" *ngIf="getCardFeeBadge()">{{getCardFeeBadge()}}</span>
        </span>
        <span class="mb-0 d-flex">
          <label class="custom-radio-checkbox mb-0"
                 *ngIf="verifyPaymentMethod(2) ">
            <input class="custom-radio-checkbox__input"
              type="checkbox"
              (change)="cardChange()"
              (click)="$event.stopPropagation()"
              [(ngModel)]="isCardSelected">
          </label>
        </span>
        <span
          *ngIf="openMethodId !== 2"
            style="position: absolute;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      border-top-right-radius: 4px;
                      border-bottom-right-radius: 4px;
                      right: 0;
                      height: 45px;
                      width: 55px;"
                      [ngStyle]="{'background-color': isCardSelected ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}">

               <i class="fa fa-caret-down"
                  aria-hidden="true"
                  [style.color]="
                                getClientsSettingAppBooking?.clients_setting_global?.color_main_1">
                </i>
          </span>

          <span
          *ngIf="openMethodId === 2"
          style="position: absolute;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      border-top-right-radius: 4px;
                      border-bottom-right-radius: 4px;
                      right: 0;
                      height: 45px;
                      width: 55px;"
                      [ngStyle]="{'background-color': isCardSelected ? getClientsSettingAppBooking?.clients_setting_global?.color_main_3 : 'white'}">

               <i class="fa fa-caret-up"
                  aria-hidden="true"
                  [style.color]="
                                getClientsSettingAppBooking?.clients_setting_global?.color_main_2">
                </i>
          </span>

      </div>
      <ng-container *ngIf="openMethodId === 2">


      <div [@slideInOut]="openMethodId === 2 ? 'in' : 'out'">
        <div class="row mx-0 pt-3 pb-3" style="background-color: #deeae7; border-bottom-right-radius: 6px; border-bottom-left-radius: 6px;">
          <div class="col-5 pl-4">
            <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 600;">Forma de pago</p>
            <p class="font-poppins" style="font-size: 13px; font-weight: 600;">TARJETA</p>
          </div>
          <div class="col-7">
            <div *ngIf="totalPrice" style="display: flex; justify-content: space-around; gap: 1em;">
              <div>
                <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 600;">TARIFA NETA</p>
                <p class="font-poppins" style="font-size: 18px; font-weight: 600;">{{currencyItinerary}} {{ getCardNetPrice() | number:'1.2-2' }}</p>
              </div>

              <!-- Fee bancario de la tarjeta (RF-02): importe con tarjeta × % de la plataforma -->
              <ng-container *ngIf="hasPaymentFees(); else cardWithoutBankFee">
                <div>
                  <p class="font-poppins d-flex align-items-center" style="margin-bottom: 0;font-size: 13px; font-weight: 600; gap: 6px;">
                    FEE BANCARIO ({{ getMethodFeePercentage(2) | number:'1.0-2' }}%)
                    <i class="fa fa-info-circle"
                       aria-hidden="true"
                       style="font-size: 14px; cursor: help;"
                       [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"
                       title="Gasto bancario de la plataforma de pago elegida. Se calcula sobre el importe que se abona con tarjeta y se suma al total de la transacción. No modifica la tarifa neta."></i>
                  </p>
                  <p class="font-poppins mb-0" style="font-size: 18px; font-weight: 600;">{{currencyItinerary}} {{ getMethodSurcharge(2) | number:'1.2-2' }}</p>
                  <p *ngIf="!selectedMethodPlatformPayment" class="font-poppins mb-0" style="font-size: 11px;">Elegí la plataforma de pago</p>
                  <p *ngIf="selectedMethodPlatformPayment" class="font-poppins mb-0" style="font-size: 11px;">
                    sobre {{currencyItinerary}} {{ getMethodNetAmount(2) | number:'1.2-2' }}
                  </p>
                </div>

                <div>
                  <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 700;">TOTAL A PAGAR</p>
                  <p class="font-poppins" style="font-size: 18px; font-weight: 700;">
                    {{currencyItinerary}} {{ (getMethodNetAmount(2) + getMethodSurcharge(2)) | number:'1.2-2' }}
                  </p>
                </div>
              </ng-container>

              <ng-template #cardWithoutBankFee>
                <div>
                  <p class="font-poppins" style="margin-bottom: 0;font-size: 13px; font-weight: 700;">A PAGAR</p>
                  <p class="font-poppins" style="font-size: 18px; font-weight: 700;">{{currencyItinerary}} {{ (leftTotal > 0 ? leftTotal : 0) | number:'1.2-2' }}</p>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Fee de productos (rentabilidad del agente): opcional, solo se abona con tarjeta -->
          <div class="col-12" *ngIf="showProductFee()">
            <div class="product-fee-line font-poppins">
              <span class="d-flex align-items-center" style="gap: 6px;">
                Fee de productos ({{ getProductFeePercentage() | number:'1.0-2' }}%)
                <i class="fa fa-info-circle"
                   aria-hidden="true"
                   style="font-size: 13px; cursor: help;"
                   [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"
                   title="Rentabilidad fijada por el agente sobre los productos. Es opcional y solo puede abonarse con tarjeta; si lo suma, se agrega al importe con tarjeta."></i>
              </span>
              <strong>{{currencyItinerary}} {{ fee | number:'1.2-2' }}</strong>
              <label class="product-fee-check mb-0">
                <input type="checkbox" [checked]="applyFee" (change)="addFee()">
                Sumar al total
              </label>
            </div>
          </div>
          <div class="col-12" *ngIf="!creditCardPending">

            <div class="platform-buttons" role="radiogroup" aria-label="Plataforma de pago con tarjeta">
              <ng-container *ngIf="currencyPayment === 'USD'">
                <button type="button"
                  class="btn platform-button"
                  role="radio"
                  title="Square"
                  [attr.aria-checked]="selectedMethodPlatformPayment === 'square'"
                  [ngStyle]="{'border-color': selectedMethodPlatformPayment === 'square' ? getClientsSettingAppBooking.clients_setting_global?.color_main_1 : null}"
                  [class.active]="selectedMethodPlatformPayment === 'square'"
                  (click)="onPaymentMethodSelected('square')">
                  <img class="platform-logo" src="assets/img/app/payments/square.svg" alt="Square">
                  <span class="fee-badge fee-badge--inline" *ngIf="getPlatformFeePercentage('square') > 0">+{{getPlatformFeePercentage('square') | number:'1.0-2'}}%</span>
                </button>

                <button type="button"
                  *ngIf="!userService._isGuest"
                  class="btn platform-button"
                  role="radio"
                  title="PayPal"
                  [attr.aria-checked]="selectedMethodPlatformPayment === 'paypal'"
                  [ngStyle]="{'border-color': selectedMethodPlatformPayment === 'paypal' ? getClientsSettingAppBooking.clients_setting_global?.color_main_1 : null}"
                  [class.active]="selectedMethodPlatformPayment === 'paypal'"
                  (click)="onPaymentMethodSelected('paypal')">
                  <img class="platform-logo" src="assets/img/app/payments/paypal.svg" alt="PayPal">
                  <span class="fee-badge fee-badge--inline" *ngIf="getPlatformFeePercentage('paypal') > 0">+{{getPlatformFeePercentage('paypal') | number:'1.0-2'}}%</span>
                </button>
              </ng-container>

              <button type="button"
                *ngIf="isMercadoPagoEnabled()"
                class="btn platform-button"
                role="radio"
                title="Mercado Pago (pago en pesos)"
                [attr.aria-checked]="selectedMethodPlatformPayment === 'mercadopago'"
                [ngStyle]="{'border-color': selectedMethodPlatformPayment === 'mercadopago' ? getClientsSettingAppBooking.clients_setting_global?.color_main_1 : null}"
                [class.active]="selectedMethodPlatformPayment === 'mercadopago'"
                (click)="onPaymentMethodSelected('mercadopago')">
                <img class="platform-logo platform-logo--wide" src="assets/img/app/payments/mercadopago.svg" alt="Mercado Pago">
                <span class="fee-badge fee-badge--inline" *ngIf="getPlatformFeePercentage('mercadopago') > 0">+{{getPlatformFeePercentage('mercadopago') | number:'1.0-2'}}%</span>
              </button>
            </div>



            <div class="col-12 d-flex justify-content-between">

            <div class="row mt-3 mb-4" *ngIf="selectedMethodPlatformPayment === 'square'">

                    <!-- Contenedor SIEMPRE visible pero oculto si no cumple condiciones -->
                   <div #squareContainer
                        id="square-card-container"
                        class="square-container"
                        [class.d-none]="!shouldShowSquareContainer()"
                        style="min-height: 150px;">
                      <!-- Square JS inyectará aquí el formulario -->
                    </div>

                    <!-- Mensaje si no se puede mostrar Square -->
                    <div *ngIf="selectedMethodPlatformPayment === 'square' && !shouldShowSquareContainer()"
                        class="alert alert-warning w-100">
                      <i class="fa fa-exclamation-triangle"></i>
                      No se puede procesar el pago con tarjeta en este momento.
                      <br>
                      <small>Verifica el monto o condiciones de pago.</small>
                    </div>

                    <!-- Mensaje de carga -->
                    <div *ngIf="selectedMethodPlatformPayment === 'square' && !isSquareReady && shouldShowSquareContainer()"
                        class="alert alert-info">
                      <i class="fa fa-spinner fa-spin"></i>
                      Inicializando formulario de pago seguro...
                    </div>

                    <!-- Botón de pago para Square -->
                    <div class="mt-3 w-100" *ngIf="isSquareReady && shouldShowSquareContainer()">
                      <button
                        id="square-pay-button"
                        class="btn btn-success btn-lg w-100"
                        (click)="userService._isGuest ? processSquarePaymentGuest() : processSquarePayment()"
                        [disabled]="isProcessing">

                        <span *ngIf="!isProcessing">
                          <i class="fa fa-lock"></i>
                          Pagar {{ amountCard | currency }} con Square
                        </span>

                        <span *ngIf="isProcessing">
                          <i class="fa fa-spinner fa-spin"></i>
                          Procesando pago...
                        </span>
                      </button>

                      <div class="mt-2 text-center">
                        <small class="text-muted">
                          <i class="fa fa-shield-alt"></i>
                          Pago seguro procesado por Square
                        </small>
                      </div>
                    </div>

                </div>

              <!-- MERCADO PAGO: el formulario (Card Payment Brick) lo renderiza Mercado Pago en sus iframes -->
              <div class="col-7 mt-3 mb-4" *ngIf="selectedMethodPlatformPayment === 'mercadopago'">
                <div [id]="mercadoPagoContainerId"
                     class="mercadopago-container"
                     [class.d-none]="!canPayWithMercadoPago()">
                </div>

                <div *ngIf="!canPayWithMercadoPago()" class="alert alert-info w-100 mb-0">
                  Ingresá el importe a pagar con tarjeta para cargar el formulario de Mercado Pago.
                </div>

                <div *ngIf="canPayWithMercadoPago() && !isMercadoPagoReady" class="alert alert-info w-100">
                  <i class="fa fa-spinner fa-spin"></i>
                  Inicializando formulario de pago seguro...
                </div>

                <div class="mt-3 w-100" *ngIf="canPayWithMercadoPago() && isMercadoPagoReady">
                  <button type="button"
                          class="btn btn-success btn-lg w-100"
                          (click)="processMercadoPagoPayment()"
                          [disabled]="isProcessing">
                    <span *ngIf="!isProcessing">
                      <i class="fa fa-lock"></i>
                      Pagar ARS {{ getMercadoPagoChargeAmount() | number:'1.2-2' }} con Mercado Pago
                    </span>
                    <span *ngIf="isProcessing">
                      <i class="fa fa-spinner fa-spin"></i>
                      Procesando pago...
                    </span>
                  </button>

                  <div class="mt-2 text-center">
                    <small class="text-muted">
                      <i class="fa fa-shield-alt"></i>
                      Pago seguro procesado por Mercado Pago. El importe final lo valida el sistema al cobrar.
                    </small>
                  </div>
                </div>
              </div>

              <div *ngIf="selectedMethodPlatformPayment === 'paypal'" class="col-7 d-flex flex-row mt-3" style="z-index: 0 " >
                <ngx-paypal [config]="payPalConfig" style="width: 100%;" *ngIf="amountCard <= totalPrice && amountCard >= 0 && !totalPayCreditCard">
                </ngx-paypal>
              </div>

              <div class="col-5 pt-3 d-flex flex-column" *ngIf="!userService._isGuest">
                <div style="display: flex; justify-content: flex-end;">
                  <div class="mr-2">
                    <input class="form-control input font-poppins"
                           id="numberInput"
                           type="number"
                           style="appearance: none;border-radius: 50rem;width:132.20px;height:38px;background-color: #f4f4f4;"
                           name="amountCard"
                           min="0"
                           [disabled]="isSelectModePay"
                           [(ngModel)]="amountCard"
                           (wheel)="preventScroll($event)"
                           (keydown)="blockInvalidKeys($event, 'number')"
                           placeholder="0,00"
                           (keydown)="verifyFeeAmountCard()"
                           [ngClass]="{'border-red': (amountCard > totalPrice)}"
                           (input)="calculateLeftTotal(); "
                           #inputCard>
                    <p *ngIf="amountCard <= totalPrice && amountCard >= 0" class="mb-0 text-center text-totals font-poppins" style="font-size: 12px !important;">PAGO A REALIZAR</p>
                    <p *ngIf="amountCard < 0" class="mb-0 text-center text-danger text-totals font-poppins" style="font-size: 12px !important;">Monto invalido</p>

                    <p *ngIf="amountCard > totalPrice" class=
                              "mb-0 text-center text-danger text-totals font-poppins" style="font-size: 12px !important;">Máximo excedido</p>
                  </div>
                  <div>
                    <button type="btn"
                            class="btn font-poppins"
                            style="font-size:12px;font-weight: 600; border-radius: 50rem;border: 1px solid black;height:38px;"
                            [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"
                            [disabled]="leftTotal === 0"
                            (click)="payTotal(4)">PAGAR COMPLETO</button>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-12" *ngIf="!userService._isGuest">
            <div class="card-table-payments">
              <p class="title-card font-poppins mb-1 ml-3">
                PAGOS PENDIENTES POR GUARDAR
              </p>
              <div class="table-payments-container">
                <table class="font-poppin my-3 mx-4" style="font-size: 12px !important">
                  <thead>
                    <tr class="mb-2">
                      <th> ID </th>
                      <th>
                      <div class="d-flex justify-content-start align-items-center">
                        FECHA <i class="i-calendar ml-2"></i>
                      </div>
                      </th>
                      <th> HORA </th>
                      <th> MONTO </th>
                      <th> PAGO TARJETA </th>
                      <th> ESTADO DE PAGO </th>
                    </tr>
                  </thead>
                  <tbody >
                    <ng-template ngFor let-paymentCreditCards [ngForOf]="paymentCreditCards" let-i="index">
                      <tr class="mb-2" *ngIf="paymentCreditCards.payment_masters_id === null">
                        <td class=""> {{paymentCreditCards.payment_id}} </td>
                        <td class=""> {{paymentCreditCards.created_at | date: 'dd/MM/yyyy'}} </td>
                        <td class=""> {{parseHour(paymentCreditCards.created_at)}} </td>
                        <td class=""> {{paymentCreditCards.amount | number:'1.2-2'}} </td>
                        <td class="">
                          <span class="status-payment" [ngClass]="{'status-payment-approved': paymentCreditCards.status.toLowerCase() == 'approved'}">{{paymentCreditCards.status}}</span>
                        </td>
                        <td class="" *ngIf="paymentCreditCards.details[0].status_id === 1"> Pendiente creación de pago</td>
                      </tr>
                    </ng-template>
                  </tbody>
                  <tfoot>
                    <tr >
                      <td class="mt-3" colspan="5" class="total-table">
                           TOTAL PAGADO: {{ totalPaymentCreditCards  | number:'1.2-2' }}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row align-items-center pr-4 mt-3 ml-auto"  *ngIf="onApprove">
            <i class="icons-success mr-2"></i>
            <p class="m-0 pay-success">SU PAGO FUE EXITOSO</p>
          </div>
        </div>
      </div>
        </ng-container>
    </ng-container>


    <!-- CREDITS -->
    <!-- <ng-container *ngIf="agency && creditPay">
      <div class="pay-method d-flex align-items-center flex-row p-2 mt-3"
        [ngClass]="{'method-selected': isCreditSelected,'method-disabled':(!verifyPaymentMethod(5))}" (click)="pointsCreditChange();">

        <span class="mb-0 d-flex">
          <label class="custom-radio-checkbox mb-0" *ngIf="verifyPaymentMethod(5)">
            <input class="custom-radio-checkbox__input" type="checkbox" (change)="pointsCreditChange()"
              [(ngModel)]="isCreditSelected">
            <span class="custom-radio-checkbox__show custom-radio-checkbox__show--radio"></span>
          </label>
        </span>
        <span class="label-check ml-2 font-poppins">POR CUENTA CORRIENTE</span>
        <i class="mr-3 ml-auto" [ngClass]="{'icons-points': !isCreditSelected, 'icons-points-dark': isCreditSelected}"></i>
        <i class="mr-2" [ngClass]="{'icons-caret': !isCreditSelected, 'icons-caret-dark': isCreditSelected}"></i>
      </div>

      <div *ngIf="isCreditSelected">
        <div class="row pt-3">
          <div class="col-6 pl-4">
            <p class="forma-pago-text font-poppins">
              <i class="icons-points ml-0 mr-2"></i>
              FORMA DE PAGO POR CUENTA CORRIENTE
            </p>
            <div class="d-flex flex-column justify-content-center text-center box-points"
              [ngClass]="{'border-red': (amountCredit > creditsActives) || (amountCredit > totalPrice) || (amountCredit < 0)}">
              <p class="mb-0 total-points font-poppins">TOTAL CUENTA CORRIENTE <span class="ml-2">$ {{creditsActives | number:'1.2-2'}}</span>
              </p>
              <P class="mb-0 saldo-points font-poppins"
                [ngClass]="{'color-red': (creditsActives - amountCredit) < 0}">
                SALDO CUENTA CORRIENTE
                <span class="ml-2" [ngClass]="{'color-red': (creditsActives - amountCredit) < 0}">
                  $ {{creditsActives - amountCredit | number:'1.2-2'}}
                </span>
              </P>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex flex-column">
              <div class="d-flex flex-row justify-content-end">
                <p class="mb-0 mr-3 text-totals font-poppins">PAGO A REALIZAR</p>
              <input class="form-control  input font-poppins" min="0"
                  [ngClass]="{'border-red': (amountCredit > creditsActives) || (amountCredit > totalPrice) || (amountCredit<0)}"
                  type="text" #inputPoints name="amountCredit" [(ngModel)]="amountCredit"
                  (change)="calculateLeftTotal()">
              </div>
              <div class="d-flex flex-row justify-content-end align-items-end ">
                <p class="mb-1 mr-3 text-totals font-poppins color-red font-weight-bold">RESTAN</p>
                <div class="form-control mt-3 input font-poppins">
                  <p class="monto-faltante">${{ leftTotal | number:'1.2-2' }} </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container> -->
    <!-- RESUMEN DE RECARGOS DEL MULTIPAGO (fase 1: estimación, no modifica lo que se cobra) -->
    <div *ngIf="hasPaymentFees() && getFeeSummaryRows().length > 0" class="fee-summary font-poppins mt-3">
      <p class="fee-summary__title mb-2">Fee bancario por forma de pago</p>
      <table class="fee-summary__table">
        <thead>
          <tr>
            <th>Método</th>
            <th class="text-right">Cancela</th>
            <th class="text-right">Fee bancario</th>
            <th class="text-right">Total transacción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of getFeeSummaryRows()">
            <td>{{row.label}} <span *ngIf="row.percentage > 0" class="fee-summary__pct">({{row.percentage | number:'1.0-2'}}%)</span></td>
            <td class="text-right">{{currencyPayment}} {{row.amount | number:'1.2-2'}}</td>
            <td class="text-right">{{currencyPayment}} {{row.surcharge | number:'1.2-2'}}</td>
            <td class="text-right">{{currencyPayment}} {{row.total | number:'1.2-2'}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>Total</td>
            <td class="text-right">{{currencyPayment}} {{getFeeSummaryTotals().amount | number:'1.2-2'}}</td>
            <td class="text-right">{{currencyPayment}} {{getFeeSummaryTotals().surcharge | number:'1.2-2'}}</td>
            <td class="text-right">{{currencyPayment}} {{getFeeSummaryTotals().total | number:'1.2-2'}}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

<!-- Fee bancario estimado de un método (se muestra debajo de su panel) -->
<ng-template #feeEstimate let-methodId>
  <div *ngIf="getMethodFeePercentage(methodId) > 0" class="fee-estimate font-poppins">
    <span>Fee bancario {{getMethodFeePercentage(methodId) | number:'1.0-2'}}%</span>
    <ng-container *ngIf="getMethodNetAmount(methodId) > 0">
      <span>· Cancela {{currencyPayment}} {{getMethodNetAmount(methodId) | number:'1.2-2'}}</span>
      <span>· Fee bancario estimado {{currencyPayment}} {{getMethodSurcharge(methodId) | number:'1.2-2'}}</span>
      <strong>· Total transacción {{currencyPayment}} {{(getMethodNetAmount(methodId) + getMethodSurcharge(methodId)) | number:'1.2-2'}}</strong>
    </ng-container>
  </div>
</ng-template>
